import React from 'react';
import './head&foot.css';
function footer() {
  return <footer>WebDev2021@Yousif</footer>;
}

export default footer;
